import React, { useState } from "react";
import { RiArrowLeftSLine } from "react-icons/ri";
import { MdKeyboardArrowRight } from "react-icons/md";

const Pagination = ({ totalItems, itemsPerPage, onPageChange }) => {
  const [currentPage, setCurrentPage] = useState(1);
  const totalPages = Math.max(1, Math.ceil(totalItems / itemsPerPage));

  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
      onPageChange(page);
    }
  };

  const rangeStart = totalItems === 0 ? 0 : (currentPage - 1) * itemsPerPage + 1;
  const rangeEnd = Math.min(currentPage * itemsPerPage, totalItems);

  return (
    <div className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between mt-6 space-x-2">
      <span className="text-sm text-slate-600">
        Showing{" "}
        <span className="font-semibold tabular-nums text-[#1B365D]">
          {rangeStart}-{rangeEnd}
        </span>{" "}
        of{" "}
        <span className="font-semibold tabular-nums text-[#1B365D]">{totalItems}</span>{" "}
        payments
      </span>
      {/* Previous Button */}
      <div className="flex items-center">
        <button
        onClick={() => handlePageChange(currentPage - 1)}
        disabled={currentPage === 1}
        className={`border border-gray-300 bg-transparent text-[20px] rounded-md p-2 ${
          currentPage === 1
            ? "bg-gray-200 text-gray-400 cursor-not-allowed"
            : "bg-white text-gray-700 hover:bg-gray-100"
        }`}
      >
        <RiArrowLeftSLine />
      </button>

      {/* Page Numbers */}
      {Array.from({ length: totalPages }, (_, i) => (
        <button
          key={i + 1}
          onClick={() => handlePageChange(i + 1)}
          className={`px-3 py-1 rounded-md border mx-2 ${
            currentPage === i + 1
              ? "bg-[#F4A261] text-white"
              : "bg-white text-gray-700 hover:bg-[#F4A261]"
          }`}
        >
          {i + 1}
        </button>
      ))}

      {/* Next Button */}
      <button
        onClick={() => handlePageChange(currentPage + 1)}
        disabled={currentPage === totalPages}
        className={`border border-gray-300 bg-transparent text-[20px] rounded-md p-2 ${
          currentPage === totalPages
            ? "bg-gray-200 text-gray-400 cursor-not-allowed"
            : "bg-white text-gray-700 hover:bg-gray-100"
        }`}
      >
        <MdKeyboardArrowRight />
      </button>
      </div>

    </div>
  );
};

export default Pagination;
